import { cn } from '@/lib/utils';

interface PillButtonProps {
  isActive: boolean;
  onClick?: () => void;
  className?: string;
  children: React.ReactNode;
}

export const PillButton: React.FC<PillButtonProps> = ({
  isActive,
  onClick,
  children,
  className,
  ...rest
}) => {
  const handleOnClick = () => {
    onClick?.();
  };

  return (
    <button
      type="button"
      aria-pressed={isActive}
      className={cn(
        'flex items-center cursor-pointer h-7 px-3 text-xs font-medium rounded-full text-gray-700 ring-1 ring-inset focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500',
        isActive
          ? 'bg-primary-600 text-white ring-primary-600/50'
          : 'bg-gray-100 ring-gray-400/50 dark:bg-dark-gray-700 dark:ring-dark-gray-600 dark:text-gray-400/80',
        className
      )}
      onClick={handleOnClick}
      {...rest}
    >
      {children}
    </button>
  );
};
